/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Vchip_DialogueInputs */

const en_subtitle_export_vchip_dialogue = /** @type {(inputs: Subtitle_Export_Vchip_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestive Dialogue`)
};

const fr_subtitle_export_vchip_dialogue = /** @type {(inputs: Subtitle_Export_Vchip_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogue suggestif`)
};

const de_subtitle_export_vchip_dialogue = /** @type {(inputs: Subtitle_Export_Vchip_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anregender Dialog`)
};

const it_subtitle_export_vchip_dialogue = /** @type {(inputs: Subtitle_Export_Vchip_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogo suggestivo`)
};

const ru_subtitle_export_vchip_dialogue = /** @type {(inputs: Subtitle_Export_Vchip_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Намекающий диалог`)
};

const es_subtitle_export_vchip_dialogue = /** @type {(inputs: Subtitle_Export_Vchip_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo sugerente`)
};

const zh_cn2_subtitle_export_vchip_dialogue = /** @type {(inputs: Subtitle_Export_Vchip_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暗示性对话`)
};

const ja_subtitle_export_vchip_dialogue = /** @type {(inputs: Subtitle_Export_Vchip_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`示唆的な会話`)
};

const hi_subtitle_export_vchip_dialogue = /** @type {(inputs: Subtitle_Export_Vchip_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संकेतात्मक संवाद`)
};

const pt_pt2_subtitle_export_vchip_dialogue = /** @type {(inputs: Subtitle_Export_Vchip_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diálogo sugestivo`)
};

/**
* | output |
* | --- |
* | "Suggestive Dialogue" |
*
* @param {Subtitle_Export_Vchip_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_vchip_dialogue = /** @type {((inputs?: Subtitle_Export_Vchip_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Vchip_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_vchip_dialogue(inputs)
	if (locale === "de") return de_subtitle_export_vchip_dialogue(inputs)
	if (locale === "it") return it_subtitle_export_vchip_dialogue(inputs)
	if (locale === "ru") return ru_subtitle_export_vchip_dialogue(inputs)
	if (locale === "es") return es_subtitle_export_vchip_dialogue(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_vchip_dialogue(inputs)
	if (locale === "ja") return ja_subtitle_export_vchip_dialogue(inputs)
	if (locale === "hi") return hi_subtitle_export_vchip_dialogue(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_vchip_dialogue(inputs)
	return en_subtitle_export_vchip_dialogue(inputs)
});